/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Creators as UpsertWorkOrderCreators } from '../store';
import Loader from '../../../Common/Loader/Loader';
// import { assetListData, assetListMeta } from '../../../../constants/sampleData';
import TabsTable from '../../../Common/Tabs_Table';
// import { Header } from '../CreateWorkorder.style';
import { Button, Div, FlexContainer } from '../../../../globalStyles';
import DynamicSVGIcon from '../../../Common/DynamicSVGIcon';
import DropArrow from '../../../../assets/icons/layout/dropdownarrow.svg';
import FilterMobileIcon from '../../../../assets/icons/Filter/Filters white.svg';
import {
  DetailLabel,
  DetailText,
  EnlargedImage,
  HeaderText,
  PartDetailsContainer,
  PartHeader,
  PartImage,
  PartName,
  PartsContainer
} from '../../WorkOrderDetails/WorkOrderDetails.style';
// import { Bttn } from '../../../../views/WorkOrders/WorkOrders.styles';
import Pagination from '../../../Common/Pagination/Pagination.view';
import { ItemsNo, Bttn } from './AssetSelection.style';
import { WorkOrderCreators } from '../../../../views/WorkOrders/store';
import { Creators as FilterCreators } from '../../../../views/Filters/store';
import { WO_TYPES } from '../../../../constants';
import SpareDetails from '../../../Stores/Spares/SpareDetails/SpareDetails.view';
import Header from '../Header';
import CartButton from '../../../Common/CartButton/CartButton';
import { isRowMatched } from '../../../Common/Tabs_Table/utility';
import { getStringLocale } from '../../../../constants/language';
import { FilterBtn } from '../../../../views/WorkOrders/WorkOrders.styles';
import WOFilter from '../../WoFilters/WOFilter';
import { isEmpty } from '../../../../shared/utility/isEmpty';
import PaginationWithPage from '../../../Common/Pagination/PaginationWithPage.view';
import PopUpModal from '../../../Common/PopUpModal/Modal.view';
import { CancelBlack } from '../../../../assets/icons';

const AssetSelection = () => {
  const dispatch = useDispatch();
  const { showFilterResult, filtersPayload, assetType } = useSelector(
    (state) => state.filterData
  );
  const {
    type,
    assetListLoading,
    assetShortlist,
    assetListMeta,
    assetListData,
    assetSearchQueries,
    workOrderCreationFrom
  } = useSelector((state) => state.upsertWorkOrder);
  const planDetails = useSelector((state) => state.plansData.planDetails);

  const setAssetSearchQueries = (searchQueries) => {
    dispatch(UpsertWorkOrderCreators.setAssetSearchQueries(searchQueries));
  };

  const location = useLocation();
  const { previousLocation } = location.state || {};

  const pageSize = 10;
  const handlePageChange = (currentPage, rest = {}) => {
    const { searchParams } = rest;
    if (filtersPayload) {
      dispatch(
        UpsertWorkOrderCreators.getAssetList({
          filtersPayload,
          pageSize,
          pageNo: currentPage,
          WFTid: type.workflowTemplateId,
          searchParams
        })
      );
    }
  };

  useEffect(() => {
    // dispatch(UpsertWorkOrderCreators.resetAssetShortlist());
  }, []);

  const isMounted = useRef(false);
  useEffect(() => {
    if (isMounted.current) handlePageChange(1);
    else {
      isMounted.current = true;
    }
  }, [filtersPayload]);
  const navigate = useNavigate();
  const handleNext = () => {
    dispatch(
      WorkOrderCreators.getUserDataByTemplateId({
        WFTid: type.workflowTemplateId,
        assetType,
        workOrderCreationFrom,
        scheduleId: planDetails.scheduleId,
        selections: assetShortlist
      })
    );
    navigate('/home/work_orders/create_WO/form', {
      state: { previousLocation }
    });
  };

  // console.log('assetListLoading, assetListMeta, assetListData', assetListLoading, assetListMeta, assetListData);

  // duplicate
  const handleShortList = (entry) => {
    const check = assetShortlist.some((ele) => isRowMatched(ele, entry));
    if (!check) {
      dispatch(
        UpsertWorkOrderCreators.setAssetShortlist([...assetShortlist, entry])
      );
    } else {
      dispatch(
        UpsertWorkOrderCreators.setAssetShortlist(
          assetShortlist.filter(
            (ele) =>
              !(
                ele.mainPartNumber === entry.mainPartNumber &&
                ele.inventPartnumber === entry.inventPartnumber
              )
          )
        )
      );
    }
  };

  const handleBack = () => {
    dispatch(
      FilterCreators.universalFilterSetter({
        key: 'showFilterResult',
        value: false
      })
    );
  };

  // for spare details modal...
  const [showSpareDetailsModal, setShowSpareDetailsModal] = useState(false);
  const [currentSpareId, setCurrentSpareId] = useState('');
  const [currentUnfurlUrl, setCurrentUnfurlUrl] = useState('');
  const handleShowDetails = (spare) => {
    setCurrentUnfurlUrl(spare?.unfurlSummaryUrl);
    setCurrentSpareId(spare.mainPartNumber);
    setShowSpareDetailsModal(true);
  };

  const resetSearchQueries = () => {
    dispatch(UpsertWorkOrderCreators.resetAssetSearchQueries());
  };

  useCallback(
    (payload) => dispatch(UpsertWorkOrderCreators.setAssetShortlist(payload)),
    [dispatch]
  );

  const [filters, setFilters] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    if (!isEmpty(assetListMeta)) {
      const filtered = assetListMeta?.columns.filter(
        (item) =>
          // item.searchable === true ||
          Array.isArray(item.options) && item.options.length > 0
      );
      const searchable = assetListMeta?.columns?.filter(
        (item) =>
          item.searchable === true &&
          Array.isArray(item.options) &&
          !item.options.length > 0 &&
          item?.type !== 'DateTime'
      );
      setFilters({ filtered, searchable });
    }
  }, [assetListMeta]);

  const handleFilterClick = () => {
    setShowFilters(true);
  };

  const [enlargeImage, setEnlargeImage] = useState({});

  return (
    <div style={{ flex: 1 }}>
      {/* <TabsTable
        handleShortList={handleShortList}
        handlePageChange={handlePageChange}
        assetShortlist={assetShortlist}
        handleTabSelect={() => {}}
        pageSize={pageSize}
        metaDetails={assetListMeta}
        dataDetails={assetListData}
        assetListLoading={assetListLoading}
        onItemSelect={handleShowDetails}
        saveSearchQueries={setAssetSearchQueries}
        savedSearchQueries={assetSearchQueries}
        resetSearchQueries={resetSearchQueries}
      /> */}
      {assetListLoading ? (
        <Loader />
      ) : (
        <div
          style={{
            height: 'calc(100vh - 26rem)',
            overflow: 'auto',
            padding: '1rem',
            position: 'relative'
          }}
        >
          <Header handleBack={handleBack}>
            {/*  name='Next' onClick={handleNext} disableNext={isDisabled} */}
          </Header>
          <FilterBtn
            style={{ top: '2rem' }}
            className='flex ai_center'
            onClick={handleFilterClick}
          >
            <DynamicSVGIcon iconUrl={FilterMobileIcon} width='20px' />
          </FilterBtn>
          {showFilters && (
            <WOFilter
              onCancel={() => setShowFilters(false)}
              filters={filters}
              workOrders={assetListData}
              handlePageChange={handlePageChange}
              setSearchQueries={setAssetSearchQueries}
            />
          )}
          {assetListData?.map((asset) => {
            const assetInList = assetShortlist.some(
              (ele) =>
                ele.mainPartNumber === asset.mainPartNumber &&
                ele.inventPartnumber === asset.inventPartnumber &&
                ele.qtyAvailable === asset.qtyAvailable
            );
            return (
              <>
                <PartsContainer>
                  <PartHeader>
                    <PartImage
                      src={asset?.unfurlImageUrl}
                      width='120px'
                      height='150px'
                      onClick={() => {
                        setEnlargeImage({ display: true, asset });
                      }}
                    />
                    <PartName>{asset?.partName}</PartName>
                  </PartHeader>
                  <PartDetailsContainer>
                    <FlexContainer className='ai_center'>
                      <DetailLabel>
                        {getStringLocale('Main Part', 'en')}
                      </DetailLabel>
                      <DetailText>{`: ${
                        asset?.mainPartNumber || '-'
                      }`}</DetailText>
                    </FlexContainer>
                    <FlexContainer className='ai_center'>
                      <DetailLabel>
                        {getStringLocale('Invent Part', 'en')}
                      </DetailLabel>
                      <DetailText>{`: ${
                        asset?.inventPartNumber || '-'
                      }`}</DetailText>
                    </FlexContainer>
                    <FlexContainer className='ai_center'>
                      <DetailLabel>
                        {getStringLocale('Location', 'en')}
                      </DetailLabel>
                      <DetailText>{`: ${asset?.location || '-'}`}</DetailText>
                    </FlexContainer>
                    <FlexContainer className='ai_center'>
                      <DetailLabel>
                        {getStringLocale('Equipment Type', 'en')}
                      </DetailLabel>
                      <DetailText>{`: ${
                        asset?.equipmenttype || '-'
                      }`}</DetailText>
                    </FlexContainer>

                    <FlexContainer className='ai_center'>
                      <DetailLabel>
                        {getStringLocale('In La', 'en')}b
                      </DetailLabel>
                      <DetailText>{`: ${asset?.inLab || '-'}`}</DetailText>
                    </FlexContainer>
                    <FlexContainer className='ai_center'>
                      <DetailLabel>
                        {getStringLocale('Qty Available', 'en')}
                      </DetailLabel>
                      <DetailText>{`: ${
                        asset?.qtyAvailable || '-'
                      }`}</DetailText>
                    </FlexContainer>
                    <FlexContainer className='ai_center'>
                      <DetailLabel>
                        {getStringLocale('Price', 'en')}
                      </DetailLabel>
                      <DetailText>{`: ${
                        asset?.BlendedCost || '-'
                      }`}</DetailText>
                    </FlexContainer>
                    <FlexContainer className='ai_center'>
                      <DetailLabel>
                        O{getStringLocale('Old P/N', 'en')}
                      </DetailLabel>
                      <DetailText>{`: ${asset?.old || '-'}`}</DetailText>
                    </FlexContainer>
                  </PartDetailsContainer>
                  <Button
                    style={{
                      borderRadius: '10px',
                      width: '100%',
                      margin: '2rem 0 0 0',
                      padding: '1rem'
                    }}
                    onClick={() => {
                      handleShortList(asset);
                    }}
                    className={assetInList && 'remove'}
                    dark={true}
                  >
                    {assetInList
                      ? getStringLocale('Remove')
                      : getStringLocale('Add')}
                  </Button>
                </PartsContainer>
              </>
            );
          })}
        </div>
      )}

      <div
        style={{
          width: '95vw',
          overflow: 'auto',
          padding: '1rem',
          margin: '1rem 0'
        }}
      >
        <PaginationWithPage
          ItemsPerPage={pageSize}
          total={assetListMeta?.count}
          handlePageChange={handlePageChange}
          searchParams={assetSearchQueries}
          isLoading={assetListLoading}
        />
      </div>
      {!assetListLoading && (
        <FlexContainer
          className='ai_center jc_center'
          style={{ width: 'calc(100vw - 1rem)' }}
        >
          <Bttn className='white' onClick={handleBack}>
            {getStringLocale('Cancel')}
          </Bttn>
          <CartButton
            showShortlistHandler={() => {
              navigate('/home/asset-shortlist');
            }}
            shortlistCount={assetShortlist.length}
            onNextHandler={handleNext}
            nextLabel='Next'
          />
        </FlexContainer>
      )}

      {
        // type.Type === WO_TYPES.SPARE_REQUEST &&
        showSpareDetailsModal && (
          <SpareDetails
            onCancel={setShowSpareDetailsModal}
            id={currentSpareId}
            currentUnfurlUrl={currentUnfurlUrl}
          />
        )
      }
      {enlargeImage?.display && (
        <PopUpModal
          closeModalHandler={() => {
            setEnlargeImage({});
          }}
          style={{ height: '60%' }}
        >
          <FlexContainer
            className='ai_center jc_spacebetween'
            style={{ marginBottom: '2rem' }}
          >
            <HeaderText>
              {getStringLocale(
                `${enlargeImage?.asset?.inventPartNumber}`,
                'en'
              )}
            </HeaderText>
            <div
              style={{ textAlign: 'end' }}
              onClick={() => {
                setEnlargeImage({});
              }}
            >
              <DynamicSVGIcon iconUrl={CancelBlack} width='1.5rem' />
            </div>
          </FlexContainer>

          <div style={{ height: '90%' }}>
            <EnlargedImage
              src={enlargeImage?.asset?.unfurlImageUrl}
              alt='part'
            />
          </div>
        </PopUpModal>
      )}
    </div>
  );
};

export default AssetSelection;
